import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { DesignFtoPermissionService } from '../design-fto-permission-service';
import { BasePlgPermissionService, type PlgAgentName } from '@/domains/shared/services/base-plg-permission-service';
import { UserInfoService } from '@telecom/shared/domain/permission/services/user-info-service';
import { CommandService } from '@patsnap/tahiti-core';
import { PlgAgentFeatureCheckApi } from '@telecom/shared/domain/permission/apis/plg-agent-feature-check-api';

/**
 * DesignFTO模块编辑权限服务实现
 */
@injectable()
export class DesignFtoPermissionServiceImpl extends BasePlgPermissionService implements DesignFtoPermissionService {
    protected readonly _agentName: PlgAgentName = 'design_fto';

    constructor(
        @inject(UserInfoService)
            userInfoService: UserInfoService,
        @inject(CommandService)
            commandService: CommandService,
        @inject(PlgAgentFeatureCheckApi)
            plgAgentFeatureCheckApi: PlgAgentFeatureCheckApi,
    ) {
        super(userInfoService, commandService, plgAgentFeatureCheckApi);
    }
}
